import { Content, Item, Root, Trigger } from '@radix-ui/react-accordion';
import { clsx } from 'clsx';
import type { AccordionProps } from './Accordion.types';

const Accordion = ({
  accordionItems,
  defaultValue,
  value,
  onItemSelect,
  disabled,
  extraClassNames,
  testId,
}: AccordionProps) => {
  return (
    <Root
      className={clsx('tw:w-full tw:rounded-md tw:focus-visible:outline-none', extraClassNames)}
      type="single"
      defaultValue={defaultValue}
      value={value}
      collapsible
      data-testid={testId}
      onValueChange={(_value) => onItemSelect(_value)}>
      {accordionItems.map((item) => (
        <Item className="tw:flex tw:w-full tw:flex-col tw:p-0" key={item.value} disabled={disabled} value={item.value}>
          <Trigger
            disabled={disabled}
            className="tw:w-full tw:cursor-default tw:bg-transparent tw:focus-visible:outline-none">
            {item.trigger}
          </Trigger>
          <Content
            className={clsx(
              'tw:overflow-hidden tw:focus-visible:outline-none tw:data-[state=closed]:animate-slideUp tw:data-[state=open]:animate-slideDown',
              item.contentClassNames,
            )}>
            {item.content}
          </Content>
        </Item>
      ))}
    </Root>
  );
};

export default Accordion;
